import { withBasePath } from '@/utils/basePath';

export const LOGOS = [
  {
    alt: 'Google Drive Logo',
    height: 160,
    src: withBasePath('/images/adaptative/googleDriveLogo.webp'),
    width: 160,
  },
  {
    alt: 'OneDrive Logo',
    height: 160,
    src: withBasePath('/images/adaptative/OneDriveLogo.webp'),
    width: 222,
  },
  {
    alt: 'Synology Logo',
    height: 160,
    src: withBasePath('/images/adaptative/synologyLogo.webp'),
    width: 240,
  },
  {
    alt: 'Dropbox Logo',
    height: 160,
    src: withBasePath('/images/adaptative/dropboxLogo.webp'),
    width: 160,
  },
  {
    alt: 'Tresorit Logo',
    height: 160,
    src: withBasePath('/images/adaptative/tresoritLogo.webp'),
    width: 160,
  },
  {
    alt: 'pCloud Logo',
    height: 160,
    src: withBasePath('/images/adaptative/pcloudLogo.webp'),
    width: 160,
  },
];
